import { useNavigate, useParams } from "react-router-dom";
import { CourseSummaryComponent, LoadingCoursePage } from "../../../components/course/view"
import { useSelector } from "react-redux";
import { LearningRecordCourse } from "src/types/coaching/learners";
import React, { useEffect, useState } from "react";
import { CourseContext, CourseContextProps } from "../../../components/course/view/context";


import { useDispatch } from "react-redux";
import { enrollCourse } from "src/redux/actions/coaching/learners";


import userRoleService from "src/services/userRoles.service";
import PermissionDenined from "src/components/permissionDenied";
import { fetchPublicCourse } from "src/redux/actions/coaching/explore";

import _ from 'lodash';
import cx from 'classnames';
import styles from "./view.module.scss";

interface EnrollCourseState {
  course: LearningRecordCourse | null;
}

export const ViewExploreCoursePage: React.FC<object> = () => {
  const dispatch = useDispatch();
  const params = useParams();
  const navigate = useNavigate();

  const courseId = params.courseId;

  const course = useSelector((state: any) =>
    _.get(state, `courses.course[${courseId}].item`),
  );

  const loading = useSelector((state: any) =>
    _.get(state, `courses.course[${courseId}].loading`),
  );

  const enrollingCourse = useSelector((state: any) => {
    const enrolling = _.get(state, `courses.course[${courseId}].enroll.enrolling`);
    return enrolling;
  });

  const courseEnrolled = useSelector((state: any) => {
    return _.get(state, `courses.course[${courseId}].enroll.enrolled`);
  });

  const courseEnrolledId = useSelector((state: any) => {
    return _.get(state, `courses.course[${courseId}].enroll.id`);
  });

  const [courseContext, setCourseContext] = React.useState<CourseContextProps>({
    id: courseId,
    startAssessment: () => { },
    endAssessment: () => { },
  });

  const [publicCourse, setPublicCourse] = useState<EnrollCourseState>({
    course: null,
  });

  useEffect(() => {
    if (courseId && !course) {
      dispatch(fetchPublicCourse({id: courseId}));
    }

    setCourseContext((prev) => {
      return {
        ...prev,
        id: courseId
      }
    });
  }, []);

  useEffect(() => {
    setCourseContext((prev) => {
      return {
        ...prev,
        onBack: handleBackClicked,
        enrollCourse: handleEnrollCourse
      }
    });

    if(!course) {
      return;
    }

    setPublicCourse((prev) => {
      return {
        ...prev,
        course: {
          id: course.id!,
          course: course,
          sessions: [],
          status: "NOT_ENROLLED",
        },
      }
    });

  }, [course]);

  useEffect(() => {
    if (courseEnrolled) {
      navigate(`/coaching/courses/${courseEnrolledId}`);
    }
  }, [courseEnrolled]);

  useEffect(() => {
    setCourseContext((prev) => {
      return {
        ...prev,
        enrollingCourse: enrollingCourse
      }
    });
  }, [enrollingCourse]);

  const handleBackClicked = () => {
    navigate(`/coaching/courses`);
  }

  const handleEnrollCourse = () => {
    if (course) {
      dispatch(enrollCourse(course.id));
    }
  }

  if(!userRoleService.canAccessCoaching()) {
    return <PermissionDenined className={styles.permissionDenied} />;
  }

  if ((loading && course?.id != courseId) || !course) {
    return (
      <div className={styles.courseContainer}>
         <div className={styles.left}>
          <div className={styles.courseDetails}>
          <div
            className={styles.back}
            onClick={() => {
              navigate(`/coaching/courses`);
            }}
          >
            <i className="paperflite-left-arrow"></i>
            <span>my courses</span>
          </div>

          <LoadingCoursePage />
        </div>
        </div>
      </div>
    );
  }


  return (
    <CourseContext.Provider value={courseContext}>
      <CourseSummaryComponent
        course={publicCourse.course!}
      />
    </CourseContext.Provider>
  );
}